import React from 'react'
import {
  Box,
  FormControl,
  FormLabel,
  HStack,
  useRadio,
  useRadioGroup,
  VisuallyHidden
} from '@chakra-ui/react'
import { useLocation } from 'react-router-dom'

interface iFormQuestaoResponse {
  id: string
  tipo: number
  enunciado: string
}

interface iENPSProps {
  questao: iFormQuestaoResponse
  updateValor: (id: string, upTexto: string) => void
  erro: boolean
}

function RadioCircle(props: any): JSX.Element {
  const { getInputProps, getCheckboxProps } = useRadio(props)
  const input = getInputProps()
  const checkbox = getCheckboxProps()

  return (
    <Box as="label" cursor="pointer">
      <VisuallyHidden>
        <input {...input} />
      </VisuallyHidden>

      <Box
        {...checkbox}
        w="36px"
        h="36px"
        borderRadius="full"
        borderWidth="1px"
        border={'solid'}
        display="flex"
        alignItems="center"
        justifyContent="center"
        fontWeight="600"
        _checked={{ bg: 'blue.500', color: 'white', borderColor: 'blue.500' }}
        _focusVisible={{ boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)' }}
        _hover={{ bg: 'blue.100' }}
      >
        {props.children}
      </Box>
    </Box>
  )
}

export function ENPS({ questao, updateValor, erro }: iENPSProps): JSX.Element {
  const [nota, setNota] = React.useState<string>('')
  const { pathname } = useLocation()

  const { getRootProps, getRadioProps } = useRadioGroup({
    name: 'enps',
    value: nota,
    onChange: (nextValue) => {
      setNota(nextValue)
      updateValor(questao.id, nextValue)
    }
  })

  return (
    <FormControl mb={3}>

      {(pathname.includes('Previsualizar') || pathname.includes('Preenchimento')) &&
          <FormLabel fontWeight={'600'}>{questao.enunciado}</FormLabel>
      }
      {erro && <span style={{ color: 'red', fontSize: '14px' }}>* Preencha este campo</span>}
      <HStack {...getRootProps()} spacing={2} wrap="wrap" mb={3}>
        {Array.from({ length: 11 }, (_, i) => {
          const radio = getRadioProps({ value: String(i) })
          return (
            <RadioCircle key={i} {...radio}>
              {i}
            </RadioCircle>
          )
        })}
      </HStack>
      <hr />
    </FormControl>
  )
}
